import React, { useContext, useState } from "react";
import { notify } from "../../generic";
import { UploadDataContext } from "./UploadDataContext";
import SelectProperty from "./SelectProperty";

const initialOptions = [
  { value: "date", label: "Date" },
  { value: "montantHT", label: "Montant HT" },
  { value: "montantTTC", label: "Montant TTC" },
  { value: "libelle", label: "Libellé transaction" }
];

const DisplayMapper = ({ data = [], selectedOptions, setSelectedOptions }) => {
  const properties = Object.entries(data);
  /*
  const [selectedOptions, setSelectedOptions] = useState(
    new Array(properties.length).fill(null)
  );*/
  const [availableOptions, setAvailableOptions] = useState(initialOptions);

  const handleSelectChange = index => selectedOption => {
    const newSelectedOptions = [...selectedOptions];
    newSelectedOptions[index] = selectedOption;

    // Mise à jour des options disponibles en fonction des options sélectionnées
    const newAvailableOptions = initialOptions.filter(
      option =>
        !newSelectedOptions.some(
          selected => selected && selected.value === option.value
        )
    );

    setSelectedOptions(newSelectedOptions);
    setAvailableOptions(newAvailableOptions);
  };

  return (
    <div className="mappingForm">
      {properties.map(([prop, value], index) => (
        <SelectProperty
          key={index}
          propertyName={prop}
          propertySample={value}
          prefilledContent={selectedOptions[index]}
          options={availableOptions}
          onChange={handleSelectChange(index)}
          noOptionsMessage={() => "Aucune option n'est disponible"}
          placeholder={prop}
        />
      ))}
    </div>
  );
};

const transformData = (selectedOptions, data) => {
  return data.map(item => {
    const newItem = {};
    selectedOptions.forEach((option, index) => {
      if (option) {
        const mappedKey = option.value;
        const originalKey = Object.keys(data[0])[index];
        newItem[mappedKey] = item[originalKey];
      }
    });
    return newItem;
  });
};

const MappingForm = () => {
  const {
    prevStep,
    nextStep,
    jsonFile = [],
    hasHeader,
    setMappedData
  } = useContext(UploadDataContext);
  let data = jsonFile[0];

  const [selectedOptions, setSelectedOptions] = useState(
    new Array(data.length).fill(null)
  );

  const handleNextStep = e => {
    const requiredFields = ["date", "libelle", "montantTTC"];

    // Transformer selectedOptions en un tableau de valeurs
    const selectedValues = selectedOptions.flatMap(option =>
      option ? option.value : []
    );

    const missingFields = requiredFields.filter(
      field => !selectedValues.includes(field)
    );

    if (missingFields.length > 0) {
      notify(
        "error",
        `Veuillez remplir les champs obligatoires suivants : ${missingFields.join(
          ", "
        )}`
      );
      return;
    }

    // Vérifiez et transformez les données selon vos besoins
    const transformedData = transformData(selectedOptions, jsonFile);
    setMappedData(transformedData);

    nextStep(e);
  };

  return (
    <div className="col-md-6">
      <h1 className="dashboardTitle">Configuration des colonnes</h1>
      <p>
        Veuillez au moins relier les colonnes{" "}
        <strong>Date, Libellé et Montant TTC</strong> de votre fichier.
      </p>
      <DisplayMapper
        data={data}
        selectedOptions={selectedOptions}
        setSelectedOptions={setSelectedOptions}
      />
      <button onClick={prevStep}>Étape précédente</button>
      <button className="right" onClick={handleNextStep}>
        Étape suivante
      </button>
    </div>
  );
};

export default MappingForm;
